<template>
        <div :class='classObj'>
            <label v-if='label'>{{ label }}</label>
            <input type='number' step='any' :key='getKey':placeholder='placeholder' :disabled='isDisabled' :name='name' v-model.number='currencyValue' @input='validate' @blur='validate' @focus='validate'>
            <span class='validationMessage'>{{ validationMessage }}</span>
        </div>
</template>

<script>
    export default{
        name: 'CurrencyInput',
        props: ['label', 'name', 'store', 'validationRules', 'disabled', 'hasErrors'],
        data() { return {   
            validationMessages: [],
            isFocused: false
        }},
        computed: {
            currencyValue: {
                get () { return this.$store.getters[this.$props.store + '/' + this.$props.name] },
                set (value) { this.$store.dispatch(this.$props.store + '/set', {field: this.$props.name, value: value === '' ? null : value.toFixed(2)}) },
            },
            classObj(){
                return{
                    CurrencyInput: true,
                        'has-error': this.valid == false || this.$props.hasErrors == true,
                        'has-success': this.valid == true,
                        'is-disabled': this.isDisabled == true,
                        'is-focused': this.isFocused == true
                }
            },
            valid(){ return this.validationMessages.length == 0 ? true : false },
            getKey(){ return this.$props.store + '_' + this.$props.name },
            isDisabled() { return this.$props.disabled || false  },
            validationMessage() { return this.validationMessages.join(', ') },
            placeholder() { return this.$props.placeholder || '' },
        },
        methods: {
            validate(e){
                if(e.type == 'focus') this.isFocused = true;
                if(e.type == 'blur') this.isFocused = false;
                this.validationMessages = [];
                var rules = this.$props.validationRules || [];
                if(e.target.checkValidity() == false)
                    this.validationMessages.push('Please enter a valid numerical value')
                else{
                    rules.forEach(rule => {
                        switch(rule){
                            case 'required':
                                if(!e.target.value)
                                this.validationMessages.push('This field is required')
                            break;
                        }
                    });
                }

                this.$emit('validate-field', { field: this.$props.name, status: this.valid})
            }
        }
    }
</script>
